import { ReactNode } from 'react';
import { ErrorBoundary } from './src/components/ErrorBoundary';
import { Layout } from './src/components/Layout';

import './src/css/global.css';

export const wrapRootElement = ({
  element,
}: {
  element: ReactNode;
}) => {
  return <Layout>{element}</Layout>;
};

export const wrapPageElement = ({
  element,
}: {
  element: ReactNode;
}) => {
  return (
    <ErrorBoundary
      onError={(err) => {
        console.log(err);
      }}
    >
      {element}
    </ErrorBoundary>
  );
};
